export const GET_PLANT_COMMON_TYPES = 'Get_Plant_Common_Types';